import React from 'react';

import ProfileSection from '/component/partial/profile/ProfileSection';
import profileTestIDs from '/constant/TestIDs/Profile';

import {ProfileBusinessItem} from './ProfileBusinessItem';
import {BUSINESS_ROW_KEYS} from './ProfileBusinessSection.constants';
import {styles} from './ProfileBusinessSection.style';
import {ProfileBusinessSectionProps} from './ProfileBusinessSection.types';

export const ProfileBusinessSection = ({
  onPress = () => {},
  healthcareStatus = 'Not registered',
  supportedLanguage = 'English',
  leadsStatus = 'Receiving leads',
  showManageMySite = false,
  showHealthcareProvider = false,
  showSupportedLanguages = false,
  showLeadsPoolOption = false,
  disableSupportedLanguages = false,
  disableHealthcareProvider = false,
  disableLeadsPoolOption = false,
}: ProfileBusinessSectionProps) => {
  return (
    <ProfileSection
      style={{base: styles.base}}
      accessibilityRole="list"
      accessibilityLabel="Business profile section"
      testID={profileTestIDs.profileBusinessSection}>
      {showManageMySite && (
        <ProfileBusinessItem
          key={BUSINESS_ROW_KEYS.MANAGE_MY_SITE}
          iconName="globe"
          label="Manage My Site"
          accessibilityLabel="Manage My Site"
          accessibilityHint="Opens Manage My Site"
          testID={profileTestIDs.profileManageMySite}
          onPress={payload =>
            onPress(BUSINESS_ROW_KEYS.MANAGE_MY_SITE, payload)
          }
        />
      )}

      {showHealthcareProvider && (
        <ProfileBusinessItem
          key={BUSINESS_ROW_KEYS.HEALTH_CARE_PROVIDER}
          iconName="stethoscope"
          label="Healthcare Provider"
          status={healthcareStatus}
          disabled={disableHealthcareProvider}
          accessibilityLabel={
            healthcareStatus
              ? `Healthcare Provider. ${healthcareStatus}`
              : 'Healthcare Provider'
          }
          accessibilityHint="Shows healthcare provider status"
          testID={profileTestIDs.profileHealthcareProvider}
          onPress={payload =>
            onPress(BUSINESS_ROW_KEYS.HEALTH_CARE_PROVIDER, payload)
          }
        />
      )}

      {showSupportedLanguages && (
        <ProfileBusinessItem
          key={BUSINESS_ROW_KEYS.SUPPORTED_LANGUAGES}
          iconName="translate"
          label="Supported Languages"
          status={supportedLanguage}
          disabled={disableSupportedLanguages}
          accessibilityLabel={
            supportedLanguage
              ? `Supported Languages. ${supportedLanguage}`
              : 'Supported Languages'
          }
          accessibilityHint="Shows supported languages"
          testID={profileTestIDs.profileSupportedLanguages}
          onPress={payload =>
            onPress(BUSINESS_ROW_KEYS.SUPPORTED_LANGUAGES, payload)
          }
        />
      )}

      {showLeadsPoolOption && (
        <ProfileBusinessItem
          key={BUSINESS_ROW_KEYS.LEADS_POOL}
          iconName="target"
          label="Leads Pool Option"
          status={leadsStatus}
          disabled={disableLeadsPoolOption}
          accessibilityLabel={
            leadsStatus
              ? `Leads Pool Option. ${leadsStatus}`
              : 'Leads Pool Option'
          }
          accessibilityHint="Shows leads pool option"
          testID={profileTestIDs.profileLeadsPool}
          isLastElement
          onPress={payload => onPress(BUSINESS_ROW_KEYS.LEADS_POOL, payload)}
        />
      )}
    </ProfileSection>
  );
};

export default ProfileBusinessSection;
